import React from 'react';
import {
  Card, Select, Upload, Icon, Button, Divider, Modal, message,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Box, Flex, Text } from '../../shared/components';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import { obtenerProveedores } from '../../../state/actions/creators/proveedores.actioncreator';
import { importarCatalogoPropio } from '../../../state/actions/creators/catalogoPropio.actioncreator';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import SelectProveedor from '../components/selectProveedor.component';
import Page from '../../shared/components/layout/Page.layout';


class nuevoCatalogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proveedor: null,
      fileList: { catalogo: null, imagenes: null },
    };
  }

  componentDidMount() {
    this.uploadCatalogosRef = React.createRef();
    this.props.obtenerProveedores();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { importarCatalogoStatus: previousImportarCatalogoStatus } = prevProps;
    const { importarCatalogoStatus } = this.props;

    handleSagaStatus({
      estadoPeticion: importarCatalogoStatus,
      previousEstadoPeticion: previousImportarCatalogoStatus,
      onWasRunningAndHasSucceded: () => {
        this.setState({ fileList: [] });
        message.success('El catálogo se está procesando.');
      },
      onWasRunningAndHasFailed: () => {
        message.error('Ha ocurrido un problema al intentar importar el catálogo');
      },
    });
  }

  onRemoveFile(name) {
    this.setState(({ fileList }) => ({
      fileList: { ...fileList, [name]: null },
    }));
    return true;
  }

  beforeUploadFile(name, file) {
    if (name === 'imagenes') {
      const zipMimes = ['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'];
      const isZip = zipMimes.includes(file.type);
      if (!isZip) {
        message.error('Formato del fichero distinto de .zip');
        return false;
      }
    } else {
      const catalogosTypes = ['text/csv', 'text/plain', 'text/*', 'application/vnd.ms-excel'];
      const isCatalogo = catalogosTypes.includes(file.type);
      if (!isCatalogo) {
        message.error('Formato del fichero distinto de .csv o .txt');
        return false;
      }
    }
    const isLt2M = file.size / 1024 / 1024 <= 90;
    if (!isLt2M) {
      message.error('Tamaño del fichero supera el máximo de 90MB');
      return false;
    }
    this.setState(({ fileList }) => ({
      fileList: { ...fileList, [name]: file },
    }));
    return false;
  }

  importarFicheros() {
    const { importarCatalogoPropio } = this.props;
    const { proveedor, fileList } = this.state;
    if (!fileList.imagenes && !fileList.catalogo) {
      message.error('Debe subir un fichero de imágenes o catálogo');
    }
    importarCatalogoPropio({ proveedor, fileList });
  }

  render() {
    const { proveedores } = this.props;
    const inIframe = window.top != window.self;
    const { uploading, fileList, proveedor } = this.state;
    return (
      <Box height="100%">
        <Page
          tituloTraduccionId={inIframe ? null : 'catalogo_propio.importacion_de_catalogos'}
          navigationItems={inIframe ? null : [
            {
              node: <Text translationId="navegacion.home" />,
              link: '',
            },
            {
              node: <Text translationId="navegacion.catalogo_propio" />,
            },
          ]}
        >
          <TwoColumnsFlexLayout
            leftContent={(
              <Box marginLeft="8px">
                <Flex>
                  <Text fontSize="16px" translationId="catalogo_propio.catalogo" />
                </Flex>
                <Flex mt="8px" width="302px">
                  <SelectProveedor filterBy="name" values={proveedores} selection={proveedor} keys={{ id: 'id', descripcion: 'nombre' }} onSelect={proveedor => this.setState({ proveedor })} />
                </Flex>
                <Flex mt="16px" size="large">
                  <Upload fileList={fileList.catalogo ? [fileList.catalogo] : []} maxCount={1} multiple={false} beforeUpload={file => this.beforeUploadFile('catalogo', file)} onRemove={() => this.onRemoveFile('catalogo')}>
                    <Button size="large" style={{ width: '302px' }}>
                      <Icon type="upload" />
                      <Text fontSize="16px" translationId="catalogo_propio.click_añadir_catalogo" />
                    </Button>
                  </Upload>
                </Flex>
                <Flex mt="8px">
                  <Text fontSize="14px" color="rgba(0,0,0,0.45)" translationId="catalogo_propio.formato_xls" />
                </Flex>
                <Flex mt="16px">
                  <Text fontSize="16px" translationId="catalogo_propio.imagenes" />
                </Flex>
                <Flex mt="8px" size="large">
                  <Upload fileList={fileList.imagenes ? [fileList.imagenes] : []} maxCount={1} ref={this.uploadCatalogosRef} multiple={false} beforeUpload={file => this.beforeUploadFile('imagenes', file)} onRemove={() => this.onRemoveFile('imagenes')}>
                    <Button size="large" style={{ width: '302px' }}>
                      <Icon type="upload" />
                      <Text ml="8px" fontSize="16px" translationId="catalogo_propio.click_añadir_imagenes" />
                    </Button>
                  </Upload>
                </Flex>
                <Flex mt="8px">
                  <Text fontSize="14px" color="rgba(0,0,0,0.45)" translationId="catalogo_propio.formato_zip" />
                </Flex>
              </Box>
                        )}
            rightContent={(
              <Flex>
                <Flex>
                  <Divider
                    type="vertical"
                    style={{
                      height: '100%', position: 'relative', color: 'black', marginBottom: '-24px',
                    }}
                  />
                </Flex>
                <Box marginRight="12px">
                  <Flex>
                    <Text fontSize="16px" translationId="catalogo_propio.informacion" />
                  </Flex>
                  <Flex>
                    <Text fontSize="16px" mt="16px" translationId="catalogo_propio.como_añadir_catalogo" />
                  </Flex>
                  <Text fontSize="14px" mt="8px" color="rgba(0,0,0,0.60)" translationId="catalogo_propio.como_añadir_imagenes_contenido" />
                  <a width="10px"><Text fontSize="14px" style={{ color: '#049BDD' }} translationId="catalogo_propio.mas_info" /></a>
                  <Flex>
                    <Text fontSize="16px" mt="16px" translationId="catalogo_propio.como_añadir_imagenes" />
                  </Flex>
                  <Flex>
                    <Text><Text fontSize="14px" mt="8px" color="rgba(0,0,0,0.60)" translationId="catalogo_propio.como_añadir_imagenes_contenido"><Text fontSize="14px" style={{ color: '#049BDD' }} translationId="catalogo_propio.mas_info" /></Text></Text>
                  </Flex>
                  <Flex>
                    <Text fontSize="16px" mt="16px" translationId="catalogo_propio.visibilidad_articulos" />
                  </Flex>
                  <Flex>
                    <Text fontSize="14px" mt="8px" color="rgba(0,0,0,0.60)" translationId="catalogo_propio.visibilidad_articulos_contenido" />
                  </Flex>
                </Box>
              </Flex>
                        )}
          />
          <Divider style={{ marginLeft: '-16px', width: '103.5%' }} />
          <Flex align="left" justifyContent="flex-end" marginBottom="6px" marginTop="-2px" style={{ align: 'right' }}>
            <Button
              size="large"
              type="primary"
              disabled={fileList.length === 0}
              loading={uploading}
              onClick={() => this.importarFicheros()}
              style={{ marginLeft: '8px' }}
            >
              Importar
            </Button>
          </Flex>
        </Page>
      </Box>
    );
  }
}


const mapStateToProps = (state) => {
  const { proveedoresWorkspace, sagas } = state;
  const { proveedores } = proveedoresWorkspace;
  return {
    proveedores,
    importarCatalogoStatus: obtenerEstadoRequestDesdeSaga(sagas, 'IMPORTAR_CATALOGO_PROPIO'),
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    obtenerProveedores,
    importarCatalogoPropio,
  }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(nuevoCatalogo);
